import React from 'react';
import styled from 'styled-components';
import { Link as DomLink } from 'react-router-dom';

const Container = styled.div`
  font-family: 'Arial', sans-serif;
  max-width: 1000px;
  margin: 20px auto;
  border-collapse: collapse;
  overflow: hidden;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const THeader = styled.th`
  background-color: #f5f5f5;
  color: black;
  padding: 20px;
  text-align: center;
  font-size: 16px;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f9f9f9;
  }
`;

const TableCell = styled.td`
  text-align: center;
  padding: 10px;
  border-top: 1px solid #ccc;
`;

const CheckMark = styled.span`
  color: green;
`;

const Button = styled.button`
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 10px;
  min-width: 150px;

  &:hover {
    background-color: #0056b3;
  }
`;


const features = [
  {
    category: 'Customer Feedback & Insights',
    options: [
      { name: 'Insights & Analytics', essentials: 'Standard', pro: 'Comprehensive', enterprise: 'Comprehensive' },
      { name: 'Segmentation', essentials: '', pro: 'Custom Segments', enterprise: 'Custom Segments' },
      { name: 'Custom Themes', essentials: '', pro: '✔', enterprise: '✔' },
      { name: 'User suggestions & issues map', essentials: '', pro: '✔', enterprise: '✔' },
      {
        name: 'NPS & Survey analysis',
        essentials: 'Limited',
        pro: 'Advanced',
        enterprise: 'Customizable with AI Writer',
      },
      { name: 'Feedback Widget', essentials: '✔', pro: '', enterprise: '✔ with Custom Branding' },
      { name: 'Adoption Meter', essentials: '', pro: '', enterprise: '✔' },
      { name: 'AI Writer for Surveys', essentials: '', pro: '', enterprise: 'Custom limits' },
      { name: 'Emerging issues & alerts', essentials: '', pro: 'Advanced with AI', enterprise: 'Custom Thresholds' },
         { name: 'Unlimited users', essentials: '', pro: '✔', enterprise: '✔' },


    ],
  },
  {
    category: 'Integrations',
    options: [
      { name: 'Zendesk', essentials: '', pro: '✔', enterprise: '✔' },
      // { name: 'Google Analytics, Heap, Sessionstack', essentials: '', pro: '', enterprise: '✔' },
      // { name: 'CRM & Marketing Integrations', essentials: '', pro: '', enterprise: 'Extended Suite' },
      { name: 'Custom Integrations', essentials: '', pro: '', enterprise: '✔' },
      // { name: 'Zapier', essentials: '', pro: '', enterprise: '✔' },
      { name: 'Rest API Access', essentials: '', pro: '', enterprise: 'Full Access' },
    ],
  },
  // {
  //   category: 'Adoption Tools',
  //   options: [
  //     { name: 'Tours & Walkthroughs', essentials: '', pro: '', enterprise: 'Unlimited' },
  //     { name: 'UI Hints & Beacons', essentials: '', pro: '', enterprise: 'Advanced Options' },
  //     { name: 'Tooltips', essentials: '', pro: '', enterprise: 'Advanced Interactivity' },
  //     { name: 'Onboarding Checklists', essentials: '', pro: '', enterprise: 'Unlimited, Customizable' },
  //     { name: 'Knowledge Base', essentials: '', pro: '', enterprise: 'SSO Access' },
  //   ],
  // },
  // {
  //   category: 'User Targeting',
  //   options: [
  //     { name: 'Custom Attributes', essentials: '', pro: '', enterprise: 'Extended Attributes' },
  //     { name: 'Dynamic Personalization', essentials: '', pro: '', enterprise: 'Advanced' },
  //     { name: 'Segmentation', essentials: '', pro: '', enterprise: 'Custom Segments' },
  //     { name: 'Custom Events', essentials: '', pro: '', enterprise: 'Unlimited' },
  //     { name: 'Tours JS Triggers', essentials: '', pro: '', enterprise: '✔' },
  //   ],
  // },
  // {
  //   category: 'NPS Survey Customization',
  //   options: [
  //     { name: 'Custom Themes', essentials: '', pro: '✔', enterprise: '✔' },
  //     { name: 'Custom CSS', essentials: '', pro: '✔', enterprise: '✔' },
  //     { name: 'Multi-language Support', essentials: '', pro: 'Up to 5 Languages', enterprise: 'Unlimited' },
  //     { name: 'White Labeling', essentials: '', pro: '', enterprise: '✔' },
  //     { name: 'Customizable Dashboard', essentials: '', pro: '✔', enterprise: 'Fully Customizable' },
  //   ],
  // },
  {
    category: 'Support',
    options: [
      {
        name: 'Live chat, Phone, Email',
        essentials: 'Email Only',
        pro: 'Email Only',
        enterprise: 'Priority Support',
      },
      { name: 'Dedicated Success Manager', essentials: '', pro: '', enterprise: '✔' },
      { name: 'Technical Implementation Manager', essentials: '', pro: '', enterprise: '✔' },
      { name: 'SLA Availability', essentials: '', pro: '✔', enterprise: 'Custom SLA' },
    ],
  },

  {
    category: 'Security & Privacy',
    options: [
      { name: 'Multi-Factor Authentication', essentials: '✔', pro: '', enterprise: 'Advanced Options' },
      { name: 'SAML SSO', essentials: '', pro: '', enterprise: '✔' },
      {
        name: 'Data Encryption',
        essentials: 'In Transit',
        pro: 'In Transit & At Rest',
        enterprise: 'Custom Solutions',
      },
      {
        name: 'GDPR Compliance',
        essentials: 'Basic Compliance',
        pro: 'Basic Compliance',
        enterprise: 'Advanced Features and Reporting',
      },
      { name: 'Data Residency Options', essentials: '', pro: '', enterprise: 'Select Regions' },
    ],
  },
  // Additional categories can be added similarly.
];
const FeatureComparison = ({ isPublic = true }) => {
  return (
    <Container>
      <Table>
        <thead>
        <tr>
          <THeader style={{ textAlign: 'left', paddingLeft: '20px' }}>Feature</THeader>
          {/*<THeader><div>Essentials</div>*/}
          {/*     {!isPublic ? (*/}
          {/*  <DomLink to='/buy-now'><Button>Buy Now</Button></DomLink> // Replace "/buy-now" with your target page's route*/}
          {/*) : (*/}
          {/*  <Button>Start free trial</Button>*/}
          {/*)}*/}
          {/*</THeader>*/}
          <THeader>
            <div>Full</div>
            {!isPublic ? (
              <DomLink to='/buy-now'><Button>Buy Now</Button></DomLink> // Replace "/buy-now" with your target page's route
            ) : (
              <Button>Start free trial</Button>
            )}
          </THeader>
          <THeader>
            <div>Enterprise Custom</div>
            <Button>Request demo</Button>
          </THeader>
        </tr>
        </thead>
        <tbody>
        {features.map((category, catIdx) => (
          <React.Fragment key={category.category}>
            <TableRow>
              <TableCell
                style={{ fontWeight: 'bold', textAlign: 'left', paddingLeft: '20px' }}>{category.category}</TableCell>
              {/*<TableCell></TableCell>*/}
              <TableCell></TableCell>
              <TableCell></TableCell>
            </TableRow>
            {category.options.map((option) => (
              <TableRow key={option.name}>
                <TableCell style={{ paddingLeft: '20px', textAlign: 'left' }}>{option.name}</TableCell>
                {/*<TableCell>{option.essentials}</TableCell>*/}
                <TableCell>{option.pro === '✔' ? <CheckMark>✔</CheckMark> : option.pro}</TableCell>
                <TableCell>{option.enterprise === '✔' ? <CheckMark>✔</CheckMark> : option.enterprise}</TableCell>
              </TableRow>
            ))}
          </React.Fragment>
        ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default FeatureComparison;